import "../sentryInstrumentReact";
import React from 'react';
import ReactDOM from 'react-dom/client';

import ProductList from "./ProductList";

const productListDiv = document.getElementById('product-list');
if (productListDiv !== null) {
  const selectDiv = ReactDOM.createRoot(productListDiv);
  selectDiv.render(
    <>
      <ProductList />
    </>
  );  
}

